import styled from 'styled-components'

export const Container = styled.div`
  text-align: center;
  overflow-x: scroll;
  display: flex;
`
